import { Pipe, PipeTransform } from '@angular/core';
import {
  EmployeeRequestResponsibleForAnswerStatusEnum,
  EmployeeRequestResponsibleForAnswerStatusLabels,
} from 'src/app/enums/employee-request-responsible-for-answer-status.enum';

@Pipe({
  name: 'remoteWorkWeekdayExceptionRequestStatus',
  standalone: true,
  pure: true,
})
export class RemoteWorkWeekdayExceptionRequestStatusPipe implements PipeTransform {
  transform(value: EmployeeRequestResponsibleForAnswerStatusEnum): string {
    return EmployeeRequestResponsibleForAnswerStatusLabels[value];
  }
}
